import { render, staticRenderFns } from "./semesterManagement.vue?vue&type=template&id=635e4aa8&scoped=true&"
import script from "./semesterManagement.vue?vue&type=script&lang=js&"
export * from "./semesterManagement.vue?vue&type=script&lang=js&"
import style0 from "./semesterManagement.vue?vue&type=style&index=0&id=635e4aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e4aa8",
  null
  
)

export default component.exports